const LABELS = {
  ptoRejected: 'pto_rejected',
  ptoApproved: 'pto_approved',
  timesheetRejected: 'timesheet_rejected',
  timesheetApproved: 'timesheet_approved',
};

export default {
  LABELS,
};



// WEBPACK FOOTER //
// ./src/store/modules/comment/constants.js